import fetch from '../utils/fetch'

export function getWxaAuthList () {
  return fetch({
    url: '/wxa/authorizer',
    method: 'get'
  })
}

export function getWxa (wid) {
  return fetch({
    url: '/wxa/' + wid,
    method: 'get'
  })
}

export function submitWxa (query) {
  return fetch({
    url: '/wxa',
    method: 'post',
    data: query
  })
}

// 获取草稿列表
export function getCgList (query) {
  return fetch({
    url: '/wxa/getCgTemplatelist',
    method: 'post',
    data: query 
  })
}
// 添加到模板库
export function addCg2Temp (query) {
  return fetch({
    url: '/wxa/addCg2Temp',
    method: 'post',
    data: query 
  })
}
// 查看模板库
export function getTempList (query){
  return fetch({
    url: '/wxa/getTempList',
    method: 'post',
    data: query 
  })
}
// 选择模板
export function useTempList (query) {
  return fetch({
    url: '/wxa/useTempList',
    method: 'post',
    data: query 
  })
} 

/**
 * 上传小程序代码
 * @param query
 */
export function submitWxa1 (query) {
  return fetch({
    url: '/wxa/new1',
    method: 'post',
    data: query
  })
}

/**
 * 提交小程序审核
 */
export function submitWxa2 (query) {
  return fetch({
    url: '/wxa/new2',
    method: 'post',
    data: query
  })
}

export function getCodeUnlimit (query) {
  return fetch({
    url: '/wxa/codeunlimit',
    method: 'get',
    params: query
  })
}

export function getTestQrcode (query) {
  return fetch({
    url: '/wxa/testqrcode',
    method: 'get',
    params: query
  })
}

export function tryRelease (query) {
  return fetch({
    url: '/wxa/tryrelease',
    method: 'post',
    data: query
  })
}

export function setPageParams (query) {
  return fetch({
    url: '/wxa/pageparams/setting',
    method: 'post',
    data: query
  })
}

export function getParamByTempName (query) {
  return fetch({
    url: '/wxa/pageparams/setting',
    method: 'get',
    params: query
  })
}

export function undocodeaudit (query) {
  return fetch({
    url: '/wxa/undocodeaudit',
    method: 'get',
    params: query
  })
}

export function revertcoderelease (query) {
  return fetch({
    url: '/wxa/revertcoderelease',
    method: 'get',
    params: query
  })
}

export function updateParamsById (query) {
  return fetch({
    url: '/wxa/pageparams/setting',
    method: 'put',
    data: query
  })
}

export function savePageParams (query) {
  return fetch({
    url: '/wxa/pageparams/setting_all',
    method: 'post',
    data: query
  })
}

export function getWxaMessageTemplateList (query) {
  return fetch({
    url: '/wxa/notice/templates',
    method: 'get',
    params: query
  })
}

export function getCustomPageList (query) {
  return fetch({
    url: '/wxa/customizepage/list',
    method: 'get',
    params: query
  })
}

export function getCustomLinkPageList (query) {
  return fetch({
    url: '/wxa/customizelink/list',
    method: 'get',
    params: query
  })
}

export function openWxaMessageTemplate (query) {
  return fetch({
    url: '/wxa/notice/templates',
    method: 'put',
    data: query
  })
}

export function createCustomPage (query) {
  return fetch({
    url: '/wxa/customizepage',
    method: 'post',
    data: query
  })
}

export function createCustomLinkPage (query) {
  return fetch({
    url: '/wxa/customizelink',
    method: 'post',
    data: query
  })
}

export function editCustomPage (id, query) {
  return fetch({
    url: `/wxa/customizepage/${id}`,
    method: 'put',
    data: query
  })
}

export function editCustomLinkPage (id, query) {
  return fetch({
    url: `/wxa/customizelink/${id}`,
    method: 'put',
    data: query
  })
}

export function delCustomPage (id, query) {
  return fetch({
    url: `/wxa/customizepage/${id}`,
    method: 'delete',
    data: query
  })
}

export function delCustomLinkPage (id, query) {
  return fetch({
    url: `/wxa/customizelink/${id}`,
    method: 'delete',
    data: query
  })
}

export function getWxaModifyDomain (query) {
  return fetch({
    url: `wxa/templates/modifyDomain`,
    method: 'post',
    data: query
  })
}

export function getWxaCustomQrcode (query) {
  return fetch({
    url: `wxa/tools/creasteQrcode`,
    method: 'post',
    data: query
  })
}

export function WebViewSetting (query) {
  return fetch({
    url: `wxa/templates/webView`,
    method: 'post',
    data: query
  })
}

/**
 * 小程序链接
 * @param query
 */
export function getgenerateUrlLink (query) {
  return fetch({
    url: '/wxa/getgenerateUrlLink',
    method: 'post',
    data: query
  })
}

export function addWxaMessageTemplate (query) {
  return fetch({
    url: '/wxa/notice/addTemplates',
    method: 'post',
    data: query
  })
}

export function editWxaMessageTemplate (query) {
  return fetch({
    url: '/wxa/notice/editTemplates',
    method: 'post',
    data: query
  })
}

export function getWxSubscriptionList (query) {
  return fetch({
    url: '/wxa/templates/getWxSubscriptionList',
    method: 'post',
    data: query
  })
}

export function getPushLogList (query) {
  return fetch({
    url: '/wxa/templates/wxSubscriptionPushLog',
    method: 'post',
    data: query
  })
}

export function sendMsg (templateId) {
  return fetch({
    url: '/wxa/notice/sendMsg/' + templateId,
    method: 'get'
  })
}

export function getTemplateVersion (query) {
  return fetch({
    url: '/wxa/pageparams/getTemplateVersion' ,
    method: 'get'
  })
}

//获取审核状态
export function getWxaAuditStatus(query) {
  return  fetch({
    url: '/wxa/version/getAuditStatus',
    method: 'get'
  })
}

// 获取最后一次提交审核状态
export function getLastAuditStatus (query) {
  return fetch({
    url: '/wxa/version/getLastAuditStatus',
    method: 'get',
    params: query
  })
}

// 获取可以回退的版本
export function getListrevertcoderelease (query) {
  return fetch({
    url: '/wxa/getlist/revertcoderelease',
    method: 'get',
    params: query
  })
}

// 回退指定版本小程序
export function versionRevertcoderelease (query) {
  return fetch({
    url: '/wxa/versionRevertcoderelease',
    method: 'get',
    params: query
  })
}

// 分阶段发布体验成员
export function grayReleaseDebug (query) {
  return fetch({
    url: '/wxa/grayReleaseDebug',
    method: 'get',
    params: query
  })
}

// 分阶段发布 全部
export function grayReleaseAll (query) {
  return fetch({
    url: '/wxa/grayReleaseAll',
    method: 'get',
    params: query
  })
}


// 分阶段发布 详情
export function getgrayReleaseDetail (query) {
  return fetch({
    url: '/wxa/getgrayReleaseDetail',
    method: 'get',
    params: query
  })
}
// 取消分阶段发布
export function revertGrayRelase(query) {
  return fetch({
    url:'wxa/revertGrayRelase',
    method: 'get',
    params: query
  })
}
// 当前小程序版本
export function getnowVersion (query) {
  return  fetch({
    url: '/wxa/version/getnowVersion',
    method: 'get',
    params: query
  }) 
}

// 清除缓存
export function clearCache (id) {
  return  fetch({
    url: '/muban/clearRedisCache?id='+id,
    method: 'get',
  }) 
}




// WEBPACK FOOTER //
// ./src/api/wxa.js